import StatusBadge from './StatusBadge';
import { useNotifications } from '../../context/NotificationContext';

const formatDate = (d) =>
  d
    ? new Date(d).toLocaleDateString('fr-FR', { day: 'numeric', month: 'short', hour: '2-digit', minute: '2-digit' })
    : '—';

const CreationRequestsList = ({ requests, isLoading, isError, error, selectedId, onSelect }) => {
  const { unreadRequestUserIds } = useNotifications();
  if (isLoading) {
    return (
      <div className="py-10 text-center text-base-content/60">
        <span className="loading loading-spinner loading-lg text-primary"></span>
      </div>
    );
  }

  if (isError) {
    return <div className="py-10 text-center text-error">Erreur : {error?.message}</div>;
  }

  if (!requests || requests.length === 0) {
    return <div className="py-10 text-center text-base-content/60">Aucune demande de création.</div>;
  }

  return (
    <div className="divide-y divide-base-200">
      {requests.map((req) => (
        <button
          key={req.userId}
          type="button"
          onClick={() => onSelect(req)}
          className={`w-full text-left px-4 py-3 hover:bg-base-200/60 transition-colors ${selectedId === req.userId ? 'bg-base-200' : ''}`}
        >
          <div className="flex items-center justify-between gap-2">
            <div className="min-w-0">
              <p className="font-medium text-sm truncate flex items-center gap-1.5">
                {unreadRequestUserIds.includes(req.userId) && (
                  <span className="inline-block w-2 h-2 rounded-full bg-error flex-shrink-0" title="Réponse du client"></span>
                )}
                <span className="truncate">{req.userInfo?.displayName}</span>
              </p>
              <p className="text-xs text-base-content/60 truncate">{req.userInfo?.email}</p>
            </div>
            <div className="flex flex-col items-end gap-1 flex-shrink-0">
              <StatusBadge status={req.status} />
              {req.trackingClosed && req.status !== 'site_publié' && (
                <span className="inline-flex items-center px-2 py-0.5 rounded-full text-[10px] font-medium bg-gray-100 text-gray-500">
                  ✓ Clôturé par le client
                </span>
              )}
            </div>
          </div>
          <p className="text-xs text-base-content/40 mt-1">
            {req.businessInfo?.nomCommercial || '—'} · {formatDate(req.updatedAt || req.submittedAt)}
          </p>
        </button>
      ))}
    </div>
  );
};

export default CreationRequestsList;
